import { EMP_LIST } from "./ActionType";
import { BASE_API_URL } from "../../config/Api";

export const empList = (token,role) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/empList?role=${role}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: EMP_LIST, payload: resData });
  } catch (error) {}
};
